import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
import { PartyGroupService } from "../services/party-group-service";
import { EntityConfigService } from "../services/entity-config-service";

export class PartyGroupListController {

    static $inject = ["$scope", "$window", "$q", "notifyService", "partyGroupService", "entityConfigService"];

    groups: Models.IPartyGroup[];
    selectedGroup: Models.IPartyGroup;
    visibilityOptions: { key: number; value: string }[];

    partyGroupModalOpen: boolean;

    constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $q: ng.IQService, private notifyService: NotifyService, private partyGroupService: PartyGroupService, private entityConfigService: EntityConfigService) {

        this.groups = [];
        this.visibilityOptions = null;

        this.partyGroupModalOpen = false;

        this.LoadPartyGroups();

    }

    LoadPartyGroups() {
        this.notifyService.startProgress();
        this.partyGroupService.getPartyGroupList()
            .then((results) => {
                this.groups = results;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    LoadVisibilityOptions() {
        return this.entityConfigService.getVisibilityOptions()
            .then((result) => {
                this.visibilityOptions = result;
            });
    }

    GetVisibilityFriendlyName(visibilityIndicator: number) {
        switch (visibilityIndicator) {
            case 0:
                return "Hidden";
            case 1:
                return "Internal Only";
            case 2:
                return "Both Internal & External";
        };
    }

    New() {

        this.selectedGroup = {
            groupID: null, divisionID: null, groupLabel: '', groupDescription: '', expandIndicator: null, expandGroupIndicator: 1, sequenceNumber: null,
            visibilityIndicator: 2, systemIndicator: 0, userId: null
        };

        this.LoadVisibilityOptions();

        this.partyGroupModalOpen = true;
    }

    Edit(partyGroup) {

        this.selectedGroup = _.clone(partyGroup);

        this.LoadVisibilityOptions();

        this.partyGroupModalOpen = true;
    }

    Update(partyGroupID: number) {
        this.notifyService.startProgress();

        if (partyGroupID == null) {
            this.partyGroupService.createPartyGroup(this.selectedGroup)
                .then((result) => {
                    this.notifyService.notifySuccess("Party Group Created");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                    this.LoadPartyGroups();
                    this.partyGroupModalOpen = false;
                });
        }
        else {
            this.partyGroupService.updatePartyGroup(this.selectedGroup)
                .then((result) => {
                    this.notifyService.notifySuccess("Party Group Updated");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                    this.LoadPartyGroups();
                    this.partyGroupModalOpen = false;
                });
        }
    }

    Delete(partyGroupID: number) {
        this.notifyService.startProgress();
        this.partyGroupService.getPartyGroupDataCount(partyGroupID)
            .then((result) => {
                if (result.data > 0) {
                    this.notifyService.notifyError("Party Group in Use");
                    this.notifyService.endProgress();
                }
                else if (result.data == 0) {
                    this.partyGroupService.deletePartyGroup(partyGroupID)
                        .then((results) => {
                            this.notifyService.notifySuccess("Party Group Deleted");
                        })
                        .finally(() => {
                            this.notifyService.endProgress();
                            this.LoadPartyGroups();
                        });
                }
                else {
                    this.notifyService.endProgress();
                }
            });
    }

    UpdateSequenceNumber(partyGroupID: number, moveUp: boolean) {
        this.notifyService.startProgress();
        this.partyGroupService.updatePartyGroupSequenceNumber(partyGroupID, moveUp)
            .then((results) => {
                this.notifyService.endProgress();
                this.LoadPartyGroups();
            });
    }

    Cancel() {
        this.ResetFields();
    }

    ResetFields() {
    }
}
